import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { EnergyAdvisorCustomer } from "@/types/energy-advisor";
import { useEnergyAdvisorDataSource } from "@/pages/energy-advisor/dataSource";

export function energyAdvisorCustomerKey(id: string) {
  return ["energy-advisor", "customer", id] as const;
}

/**
 * Detail query for the Energy Advisor customer view. Disabled when `id` is
 * undefined (e.g. before the route param resolves) so consumers can call it
 * unconditionally and rely on `data` being populated only when the id is
 * known.
 *
 * Routes via the active `EnergyAdvisorDataSource` — the authenticated
 * workspace hits `/api/energy-advisor/customers/:id`, the public share viewer
 * hits `/api/public/energy-advisor/share/:token/customer`.
 */
export function useEnergyAdvisorCustomer(id: string | undefined) {
  const source = useEnergyAdvisorDataSource(id);
  return useQuery({
    queryKey: id
      ? [...source.queryKeyPrefix, "customer"]
      : ([...source.queryKeyPrefix, "customer", "no-id"] as const),
    queryFn: () => api.get<EnergyAdvisorCustomer>(source.endpoint("")),
    enabled: !!id,
  });
}
